import React from 'react';
import { useCart } from '../context/CartContext';

export default function FloatingCartButton() {
  const { totalItems, totalPrice, openCart } = useCart();

  if (totalItems === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40 animate-in fade-in slide-in-from-bottom-4 duration-200">
      <button
        type="button"
        onClick={openCart}
        className="group flex items-center gap-3 px-5 py-3.5 rounded-2xl bg-[#39463A] hover:bg-[#273228] text-white shadow-xl hover:shadow-2xl border border-[#71806A]/40 transition-all duration-300 active:scale-95 cursor-pointer"
        aria-label={`Åbn bestillingskurv med ${totalItems} varer`}
      >
        {/* Basket icon with animated badge */}
        <div className="relative">
          <i className="fa-solid fa-basket-shopping text-lg text-[#BCC6B2] group-hover:text-white transition-colors" />
          <span className="absolute -top-2.5 -right-2.5 min-w-[20px] h-5 px-1.5 rounded-full bg-[#B98262] text-white text-[11px] font-extrabold flex items-center justify-center shadow-md">
            {totalItems}
          </span>
        </div>

        {/* Text and Total Price */}
        <div className="text-left flex flex-col">
          <span className="text-[11px] font-bold uppercase tracking-wider text-[#DED3C0]">
            Bestilling
          </span>
          <span className="text-xs font-extrabold text-white">
            {totalPrice > 0 ? `${totalPrice} kr.` : `${totalItems} ${totalItems === 1 ? 'vare' : 'varer'}`}
          </span>
        </div>

        <i className="fa-solid fa-chevron-right text-[11px] text-[#BCC6B2] group-hover:translate-x-0.5 transition-transform" />
      </button>
    </div>
  );
}
